// Shared deposit/instalment schedule math for the Your Tour quote letter.
// £100-per-paying-player deposit due in 2 weeks; remaining balance split
// evenly across a 2nd instalment (midpoint) and a final instalment due
// 2 months before departure. Mirrors the same formula already duplicated in
// generateQuoteLetterPdf.js and generateConfirmationLetterPdf.js.

function addDays(dateStr, days) {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

function subtractMonths(dateStr, months) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  d.setMonth(d.getMonth() - months);
  return d.toISOString().slice(0, 10);
}

function midDateStr(a, b) {
  if (!a || !b) return '';
  return new Date(Math.round((new Date(a).getTime() + new Date(b).getTime()) / 2))
    .toISOString().slice(0, 10);
}

export function computeDepositSchedule(payingPlayers, totalCost, departureDate) {
  const quoteDate = new Date().toISOString().slice(0, 10);
  const depositDueDate = addDays(quoteDate, 14);
  const finalDueDate = subtractMonths(departureDate, 2);
  const instalment2DueDate = midDateStr(depositDueDate, finalDueDate);

  const depositAmt = (Number(payingPlayers) || 0) * 100;
  const remaining = Math.max(0, (Number(totalCost) || 0) - depositAmt);
  const instalment2Amt = Math.round(remaining * 0.5 * 100) / 100;
  const instalment3Amt = Math.round((remaining - instalment2Amt) * 100) / 100;

  return {
    depositAmt,
    instalment2Amt,
    instalment3Amt,
    depositDueDate,
    instalment2DueDate,
    finalDueDate,
  };
}
